import { TalentPreviewUI } from "features";

const TalentEnablementPreview = () => {
  return (
    <>
      <TalentPreviewUI />
    </>
  );
};

export { TalentEnablementPreview };
